import React, { FC, ReactNode, useEffect } from 'react';
import Button from "@mui/material/Button";

interface MainLayoutProps {
    children: ReactNode;
    mobile: boolean;
    fullWidth?: boolean
    submit?: boolean,
    click?: any
    enterPress?: boolean
    disabled?: boolean
}


const MyBtn: FC<MainLayoutProps> = ({
    children,
    click,
    mobile,
    fullWidth,
    submit,
    enterPress,
    disabled
}) => {

    useEffect(() => {
        const globalKeyDownHandler = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && enterPress && click !== undefined) {
                event.preventDefault();
                click();
            }
        };
        window.addEventListener('keydown', globalKeyDownHandler);
        return () => {
            window.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [click, enterPress]);

    return (
        <Button
            onClick={click}
            fullWidth={!!fullWidth}
            variant="outlined"
            type={submit ? "submit" : undefined}
            disabled={disabled}
            sx={{
                background: disabled
                    ? '#b9b9b9'
                    : 'linear-gradient(135deg, #581c87, #a855f7)', // use `background`, not `backgroundColor`
                color: '#ffffff',
                textTransform: 'capitalize',
                borderRadius: "20px",
                fontSize: 12,
                display: mobile ? { xs: 'none', md: 'flex' } : 'flex',
                transition: 'background 0.3s, transform 0.2s',
                ':hover': {
                    background: disabled
                        ? '#b9b9b9'
                        : '#15803D', // solid hover color if not disabled
                    transform: disabled ? 'none' : 'translateY(-1px)' // optional: tiny lift on hover
                }
            }}
        >
            {children}
        </Button>

    );
};

export default MyBtn;
